import { memo } from "react";
import Modal from "ui/atoms/Modal";
import { useWaTemplateSetupContext } from "./WaTemplateSetupProvider";
import WaTemplateSetupView from "./WaTemplateSetupView";
import WaTemplateSetupForm from "./WaTemplateSetupForm";

const TITLE_BY_MODE = {
    view: 'View Template Setup',
    edit: 'Edit Template Setup',
    create: 'Create Template Setup'
} as const;

const WaTemplateSetupDetail = () => {
    const { open, mode, resource, onClose } = useWaTemplateSetupContext();

    const title = mode ? TITLE_BY_MODE[mode] : '';

    return (
        <Modal
            isOpen={open}
            disableCloseOnBackdropClick
            titleSlot={title}
            onClose={onClose}
            DialogProps={{
                sx: {
                    '& .MuiPaper-root': {
                        maxWidth: 750
                    }
                }
            }}
        >
            {mode === 'view' && resource && (
                <WaTemplateSetupView resource={resource} />
            )}
            {(mode === 'edit' || mode === 'create') && (
                <WaTemplateSetupForm resource={resource} />
            )}
        </Modal>
    );
};

export default memo(WaTemplateSetupDetail);
